import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import $ from 'jquery';
import onClickOutside from 'react-onclickoutside';
import { withHotKeys, ShortcutType } from '@bingads-webui-react/hot-keys';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { SearchBox } from '@bingads-webui-react/search-box-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { withUserConsumer } from '@bingads-webui-react/user-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { ScopeV2 } from '@bingads-webui-react/with-site-map';
import { keyName } from '@bingads-webui/keycode';
import { CopilotIcon } from '@bingads-webui-react/copilot-ui-base';
import { isCopilotRegionRestricted } from '@bingads-webui-react/copilot-utils';
import { getDefaultGlobalSearchStyles } from './default-global-search-styles';
import { renderPageSearch } from './page-result-view';

const TOTAL_SEARCH_RESULTS_NUM = 8;

const CopilotLogo = ({
  classes,
  title,
  onCopilotClick,
  isNewLogo,
}) => {
  const openCopilot = () => onCopilotClick({ forceOpen: true });
  const onCopilotKeyDown = (e) => { if (e && e.key === 'Enter') { openCopilot(); } };

  return (
    <div role="button" tabIndex={0} className={classnames(classes.copilotIcon, 'global-search-copilot-icon')} onClick={openCopilot} onKeyDown={onCopilotKeyDown}>
      <CopilotIcon
        size="medium"
        color={isNewLogo ? 'multicolor' : 'blue'}
        title={title}
      />
    </div>
  );
};

class GlobalSearch extends React.PureComponent {
  constructor(props) {
    super(props);

    this.searchActivity = this.props.instrumentation.globalSearchScenario.create()
      .searchActivity.create();

    this.state = {
      searchQuery: '',
      dropdownVisible: false,
      scope: props.scope,
      isAdsCopilotEnabled: false,
    };
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (state.scope !== nextProps.scope) {
      return { searchQuery: '', scope: nextProps.scope };
    }
    return null;
  }

  componentDidMount() {
    isCopilotRegionRestricted({ feature: 'Chat', permissions: this.props.permissions, serverContext: this.props.serverContext })
      .then(isRestricted => this.setState({ isAdsCopilotEnabled: !isRestricted }));
  }

  componentDidUpdate(prevProps) {
    if (this.props.hotKey === 'g+t' && prevProps.count !== this.props.count) {
      $('.global-search-container input').focus();
    }
  }

  onKeyDown = (event) => {
    // escape
    if (event && event.key === keyName[0x1B]) {
      this.setState({ dropdownVisible: false });
    }
  };

  getSearchActivityTraceLog = ({
    isSearchResultSelected,
    selectedItem = '',
  }) => ({
    keyword: this.state.searchQuery,
    isSearchResultSelected,
    selectedItem,
  });

  getSearchItemUniqueId = item => item && item.route;

  showDropdown = () => {
    this.setState({ dropdownVisible: true });
  };
  clear = () => {
    this.searchQueryChanged('');
    this.props.afterDismissSearchResult();
    this.setState({ dropdownVisible: false });
  };

  handleClickOutside = () => {
    if (this.state.searchQuery !== '') {
      this.searchActivity.trace(this.getSearchActivityTraceLog({ isSearchResultSelected: false }));
    }

    this.clear();
  };

  searchQueryChanged = (newSearchQuery) => {
    if (!this.state.dropdownVisible) {
      this.setState({ dropdownVisible: true });
    }
    this.setState({ searchQuery: newSearchQuery });
  };

  render() {
    const {
      classes,
      i18n,
      scope,
      siteMap,
      renderSearchResults,
      searchEngines,
      isNewSearchBox,
      onCopilotClick,
    } = this.props;

    const isNewLogo = _.get(this.props.permissions, ['dynamic', 'AdsCopilotUxImprovements']);

    const copilotLogo = this.state.isAdsCopilotEnabled ?
      (<CopilotLogo classes={classes} title={i18n.getString(_TL_('Copilot icon'))} onCopilotClick={onCopilotClick} isNewLogo={isNewLogo} />) : undefined;
    let renderExtraContent;
    const currentScope = ScopeV2.getCurrentScope(scope.values);
    if (currentScope.isChildOf(ScopeV2.Customer)) {
      renderExtraContent = (
        <div className={classnames([classes.extraContent, this.state.isAdsCopilotEnabled && 'search-both-shortcut-copilot'])}>
          <div className={classes.shortcutItem}>
            <div className={classes.shortcutKey}>G</div>
            <div className={classes.shortcutKey}>T</div>
          </div>
          {copilotLogo}
        </div>);
    } else {
      renderExtraContent = (
        <div className={classnames([classes.extraContent, this.state.isAdsCopilotEnabled && 'search-only-copilot'])}>
          {copilotLogo}
        </div>);
    }

    const searchResultsNum = Math.ceil(TOTAL_SEARCH_RESULTS_NUM / renderSearchResults.length);
    const searchResults = renderSearchResults.map(renderSearch => renderSearch({
      searchEngines,
      searchActivity: this.searchActivity,
      getSearchItemUniqueId: this.getSearchItemUniqueId,
      searchQuery: this.state.searchQuery,
      clear: this.clear,
      siteMap,
      i18n,
      searchResultsNum,
    }));

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        className={isNewSearchBox ? classnames(classes.newGlobalSearchContainer, 'new-global-search-container') : classnames(classes.globalSearchContainer, 'global-search-container')}
        onKeyDown={e => this.onKeyDown(e)}
      >
        <SearchBox
          onQueryChange={query => this.searchQueryChanged(query)}
          value={this.state.searchQuery}
          placeholder={i18n.getString(_TL_('Search Microsoft Advertising'))}
          onSearch={_.noop}
          onFocus={this.showDropdown}
          renderExtraContent={renderExtraContent}
          showArrowIcon={false}
        />
        {(this.state.dropdownVisible) && searchResults}
      </div>
    );
  }
}

CopilotLogo.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getDefaultGlobalSearchStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  title: PropTypes.string.isRequired,
  onCopilotClick: PropTypes.func.isRequired,
  isNewLogo: PropTypes.bool,
};

CopilotLogo.defaultProps = {
  isNewLogo: false,
};

GlobalSearch.propTypes = {
  searchEngines: PropTypes.arrayOf(PropTypes.shape({ search: PropTypes.func })),
  classes: PropTypes.shape(_.mapObject(
    getDefaultGlobalSearchStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      Shortcuts: PropTypes.bool,
      EnhancedSearch: PropTypes.bool,
      CampaignSearch: PropTypes.bool,
      AdsCopilotRegionRestriction: PropTypes.bool,
      CNMarketExpansion: PropTypes.bool,
    }),
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  hotKey: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  userContext: PropTypes.shape({
    CurrentAccount: PropTypes.object,
  }),
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })).isRequired,
  instrumentation: PropTypes.shape({
    globalSearchScenario: PropTypes.any,
  }).isRequired,
  renderSearchResults: PropTypes.arrayOf(PropTypes.func),
  isNewSearchBox: PropTypes.bool,
  afterDismissSearchResult: PropTypes.func,
  onCopilotClick: PropTypes.func,
  serverContext: PropTypes.shape({}).isRequired,
};

GlobalSearch.defaultProps = {
  searchEngines: undefined,
  userContext: {},
  renderSearchResults: [
    renderPageSearch,
  ],
  isNewSearchBox: false,
  afterDismissSearchResult: _.noop,
  onCopilotClick: _.noop,
};

export const StyledGlobalSearch =
  // eslint-disable-next-line max-len
  withInstrumentation(withUserConsumer(withScope(withI18nConsumer(withPermissions(withHotKeys(withDefaultStyles(
    onClickOutside(GlobalSearch),
    getDefaultGlobalSearchStyles
  ), ShortcutType.GlobalSearch))))));

export const StyledGlobalSearchWithoutClickOutside =
  // eslint-disable-next-line max-len
  withInstrumentation(withUserConsumer(withScope(withI18nConsumer(withPermissions(withHotKeys(withDefaultStyles(
    GlobalSearch,
    getDefaultGlobalSearchStyles
  ), ShortcutType.GlobalSearch))))));

export const StyledGlobalSearchWithoutHotKey =
  // eslint-disable-next-line max-len
  withInstrumentation(withUserConsumer(withScope(withI18nConsumer(withPermissions(withDefaultStyles(
    onClickOutside(GlobalSearch),
    getDefaultGlobalSearchStyles
  ))))));

export const StyledGlobalSearchWithoutHotKeyOrClickOutside =
  // eslint-disable-next-line max-len
  withInstrumentation(withUserConsumer(withScope(withI18nConsumer(withPermissions(withDefaultStyles(
    GlobalSearch,
    getDefaultGlobalSearchStyles
  ))))));
